import { Container, Row, Col } from "react-bootstrap";
import './deviceDetails.scss'
import './global.scss'
import { Button, Input, Dropdown, Loader } from 'sfy-react'
import Header from "./trHeader";
import { useEffect, useState, } from "react";
import { useHistory, useLocation } from 'react-router-dom';
import DummyData from './apiResponses'
import { postRequestAsync } from "./genericApi";
import constants from "./constants";
import { setDashboardError } from "../../store/common";
import { regex } from "./regex";
import forward from './assets/forward.png'
import ButtonContainer from "./buttonContainer";
import ErrorModal from "./Modal/errorModal";
import { getAmpleStoreDetails } from './apiInstance';
import pushToAnalytics, { getTimeDiff } from "./Analytics";
function DeviceDetails(props) {
 const { changeScreen, currentIndex } = props;
 const [imei, setImeiNumber] = useState("");
 const [brandId, setBrandId] = useState("");
 const [disableBtn, setDisableBtn] = useState(true);
 let ampleStoreDetails = getAmpleStoreDetails();
 const PSLId = ampleStoreDetails["pslid"];
 const PSCId = constants.PSCId;
 const location = useLocation();
 const [brands, setBrands] = useState(DummyData.getBrands && DummyData.getBrands.data);
 const [selectedBrand, setSelectedBrand] = useState("");
 const [apiError, setError] = useState("");
 const [showSkuScreen, setShowSkuScreen] = useState(false);
 const [showModal, setShowModal] = useState(false);
 const [products, setProducts] = useState([]);
 const [selectedModel, setSelectedModel] = useState("");
 const [skuDetails, setSkuDetails] = useState([]);
 const [selectedVariant, setSelectedVariant] = useState("")
 const [productId, setProductID] = useState("");
 const [showLoader, setShowLoader] = useState(true);
 const [enableShowConfirmBtn, setEnableShowConfirmBtn] = useState(false);
 const [enterTime, setEnterTime] = useState(new Date())
 useEffect(() => {
  if (apiError) setShowModal(true);
 }, [apiError])

 useEffect(() => {
  const currentTime = new Date();
  console.log("currentTime", currentTime)
  setEnterTime(currentTime);
 }, [])
 useEffect(() => {
  (async () => {
   localStorage.setItem("ampleWebUserId", ampleStoreDetails["userid"]);
   console.log(PSLId);
   console.log(ampleStoreDetails["userid"]);
   setShowLoader(true);
   try {
    const brands_list = await postRequestAsync('/api/v2/TradeIn/getBrands', { "ProductSubCategoryID": PSCId, "IsTradeIn": 1, "PartnerServiceLocationID": PSLId })
    let dev = brands_list && brands_list.data && brands_list.data.brands;
    // if (dev) dispatch(set_brand_list(dev));
    let obj = [];
    dev && dev.forEach(el => {
     obj.push({
      value: el.BrandName,
      id: el.BrandID
     })
    });
    setBrands(obj);
    setShowLoader(false);
   }
   catch (e) {
    setShowLoader(false);
   }

  })()
 }, []);
 const InputComponent = (props) => {
  const { label, value } = props;
  return <Input
   label={label}
   value={value}
   isDisabled={false}
   handleOnChange={(e) => {

   }
   }
   className={{ inputContainer: 'user-details-input', label: 'input-container-label' }}
   id='input-username-id'
   labelAlign='top'
  />
 }
 const on_tradein_continue_btn_click = async () => {
  if (showSkuScreen) return;
  localStorage.setItem("ampleBrand", brandId);
  localStorage.setItem("ampleImei", imei);
  setError("");
  setShowLoader(true);
  pushToAnalytics(
   'Device Confirmation - IMEI',
   {
    Unique_Key:localStorage.getItem('ampleUniquekey')
   }
  )
  try {
   const productDetails = await postRequestAsync('/api/v2/TradeIn/getDeviceDetailsOnPUID', {
    "UserID": +localStorage.getItem("ampleWebUserId"),
    "ProductSubCategoryID": PSCId,
    "BrandID": brandId,
    "PartnerServiceLocationID": PSLId,
    "ProductUniqueID": imei,
    "Flow": "TRADE_IN"
   });
   if (productDetails && productDetails.data && productDetails.data.product && productDetails.data.product.ProductID) {
    localStorage.setItem("ampleProductID", productDetails.data.product.ProductID);
    setProductID(productDetails.data.product.ProductID)

   }
   if (productDetails && productDetails.data && productDetails.data.integrationDetails) {
    localStorage.setItem("ampleintegrationDetails", productDetails.data.integrationDetails);
   }
   getProducts();
   setDisableBtn(false);
  }
  catch (e) {
   console.log(e);
   setDisableBtn(true);
   pushToAnalytics(
    'Device Confirmation - Error',
    {
     Brand: selectedBrand,
     Unique_Key:localStorage.getItem('ampleUniquekey')
    }
   );
   if (e && e.msg) {
    let m = e.msg.split(".");
    if (m.length != 0) {
     setError(`${m[0] || ""}.${m[1] || ""}.`);
    }
   }
   setShowLoader(false);
  }
  const inputElements = document.querySelectorAll('.input-container .input');
  inputElements.forEach((input) => {
   input.style.padding = '10px 0 !important';
  });

  const buttons = document.querySelectorAll(".imei_btn_normal");
  buttons.forEach((button) => {
   if (!button.classList.contains("imei_btn_rod")) {
    button.classList.remove("imei_btn_normal");
    button.classList.add('imei_btn_rod');
   }
  });
 }
 const closeModal = () => {
  setShowModal(false);
  setError("");
 }


 const getProducts = async () => {
  try {
   const product_list = await postRequestAsync('/api/v2/TradeIn/getProducts',
    {
     "ProductSubCategoryID": PSCId,
     "IsTradeIn": 1,
     "BrandID": brandId,
     "PartnerServiceLocationID": PSLId
    }
   )
   let dev = product_list && product_list.data && product_list.data.products;
   // if (dev) dispatch(set_brand_list(dev));
   let obj = [];
   dev && dev.forEach(el => {
    obj.push({
     value: el.ProductName,
     id: el.ProductID
    })
   });
   setProducts(obj);
   if (productId && obj && obj.length > 1) {
    let selectedModel = obj.filter((p) => (p.id == productId));
    if (selectedModel && selectedModel.length > 0) {
     setSelectedModel(selectedModel[0]);
     console.log("setSelectedModel--",selectedModel[0].value);
     localStorage.setItem("ampleModelName", selectedModel[0].value)
     onProductSelection(selectedModel[0])
    }
   }
   setShowLoader(false);
   setShowSkuScreen(true);
  }

  catch (e) {
   setShowLoader(false);
   if (e && e.msg) setError(e.msg);
  }
 }

 const on_tradein_sku_continue_btn_click = async () => {
  pushToAnalytics(
   'Device Confirmation - Confirm',
   {
    Brand: selectedBrand,
    Model: selectedModel && selectedModel.value,
    Variant: selectedVariant,
    Unique_Key:localStorage.getItem('ampleUniquekey')
   }
  )
  changeScreen("inspection");
  currentIndex(2)
 }

 const onProductSelection = async (val) => {
  const skuDetails = await postRequestAsync('/api/v2/TradeIn/getSKUDetails',
   {
    "ProductID": val.id,
    "IsTradeIn": 1,
    "PartnerServiceLocationID": PSLId
   })
  let models = skuDetails && skuDetails.data && skuDetails.data.skuModels;
  localStorage.setItem("ampleProductID", val.id);
  let variants = [];
  let selectedModel = models.filter((el) => val.id == el.ProductID);
  if (selectedModel && selectedModel.length > 0) {
   for (var model of selectedModel) {
    let SkuID = model.SkuModelID;
    let varStr = "";
    for (var variant of model.skuModelAttributes) {
     varStr += variant.Value + " ";
    }
    variants.push({ SkuModelID: SkuID, str: varStr });
   }
   setSkuDetails(variants.map(el => { return { 'SkuModelID': el.SkuModelID, "id": el.str, "value": el.str } }));
  }

  if (selectedModel && selectedVariant) {
   setDisableBtn(false)
  } else {
   setDisableBtn(true)

  }
  // const buttons = document.querySelectorAll(".imei_btn_disable");
  // buttons.forEach((button) => {
  //   button.classList.remove("imei_btn_disable");
  // });
  const buttons = document.querySelectorAll(".imei_btn_disable");
  buttons.forEach((button) => {
   if (!button.classList.contains("imei_btn_rod")) {
    button.classList.remove("imei_btn_disable");
    button.classList.add('imei_btn_rod');
   }
  });

 }
 const on_back_btn_click = () => {
  setShowSkuScreen(false);
  setSelectedModel({});
  setSelectedVariant("")
  setDisableBtn(false);
  setEnableShowConfirmBtn(false)
  const buttons = document.querySelectorAll(".imei_btn_rod");
  buttons.forEach((button) => {
   if (!button.classList.contains("imei_btn_normal")) {
    button.classList.add("imei_btn_normal");
    button.classList.remove('imei_btn_rod');
   }
  });
  pushToAnalytics(
   'Device Confirmation - Back',
   {
    Unique_Key:localStorage.getItem('ampleUniquekey')
   }
  )
 }
 return (
  <Container fluid className="p-0 m-0 g-0" style={{ backgroundColor: '#FFFFFF', height: "100%" }}>
   {
    showLoader ?
     <Loader />
     :
     ''
   }
   <div>
    <div style={{ padding: '24px' }}>
     <div style={{ width: "100%", display: "flex", justifyContent: "center", fontSize: "1.3rem", alignItems: "center", lineHeight: "1.6", fontWeight: "bolder" }}>
      Select your old device
     </div>
     <div className="device_details_subheader paragraph_center">Please select the brand, model and variant of your old device</div>
     <div style={{ marginTop: "30px" }}>
      <Row>
       <div className='dt-input-title'>Brand</div>
       <Col xs={12} style={{ marginTop: '5px' }}>
        {
         <Dropdown
          id='dropdown'
          value={selectedBrand}
          options={brands}
          placeholder='Select from the list'
          showDownArrow={true}
          handleOnChange={(v) => {
           setError("");
           setSelectedBrand(v.value);
           localStorage.setItem("ampleBrandName", v.value)
           setBrandId(v.id);
           setImeiNumber("");
           if (brandId && imei) {
            if (imei.length === 16) {
             setDisableBtn(false)
            }
            else if (brandId == 4 && (imei.length >= 9 && imei.length <= 12)) {
             setDisableBtn(false)
            }
            else {
             setDisableBtn(true)
            }
           } else {
            setDisableBtn(true)
           }
          }}
          filterBy='value'
          searchText='Select Brand'
          isDisabled={showSkuScreen}

         />

        }
       </Col>
       <Col xs={12} style={{ marginTop: '15px' }}>
        {brandId !== 4 && <Input
         label={"Enter Serial Number / IMEI"}
         value={imei}
         maxLength={15}
         isDisabled={showSkuScreen}
         placeholder='Enter the Serial Number / IMEI of the device'
         handleOnChange={(e) => {
          if (/^\d*$/.test(e.target.value)) {
           let _imei = e && e.target.value;
           setImeiNumber(_imei);
           if (brandId && _imei) {
            if (_imei.length === 15) {
             setDisableBtn(false)
            }
            else setDisableBtn(true)
           }
           else {
            setDisableBtn(true)
           }
          }
          setError("");
         }
         }
         className={{ inputContainer: 'user-details-input', label: 'input-container-label' }}
         id='input-username-id'
         labelAlign='top'
        >

         <div className={disableBtn ? "imei_btn_disable" : "imei_btn_normal"} onClick={on_tradein_continue_btn_click}>
          <img alt="" src={forward} />
         </div>
        </Input>}
        {brandId === 4 && <Input
         label={"Enter Serial Number / IMEI"}
         value={imei}
         maxLength={15}
         placeholder='Enter the Serial Number / IMEI of the device'
         isDisabled={showSkuScreen}
         handleOnChange={(e) => {
          let _imei = e && e.target.value.toUpperCase().replace(/[^a-zA-Z0-9]/g, "");
          setImeiNumber(_imei);
          if (brandId && _imei) {
           let isNumeric = regex['numeric'].test(e.target.value);
           let isAlphanumeric = regex['alphanumeric'].test(e.target.value);
           if (_imei.length === 15 && isNumeric) {
            setDisableBtn(false)
           }
           else if (brandId == 4 && (_imei.length >= 10 && _imei.length <= 12) && isAlphanumeric) {
            setDisableBtn(false)
           } else {
            setDisableBtn(true)
           }
          }
          else {
           setDisableBtn(true)
          }
          setError("");
         }
         }

         className={{ inputContainer: 'user-details-input', label: 'input-container-label' }}
         id='input-username-id'
         labelAlign='top'
        >

         <div className={disableBtn ? "imei_btn_disable" : "imei_btn_normal"} onClick={on_tradein_continue_btn_click}>
          <img alt="" src={forward} />
         </div>
        </Input>}
       </Col>
       <div className="input-container-label" style={{ width: "100%", display: "flex", justifyContent: "flex-start", fontSize: "0.6rem", marginTop: "5px" }}>
        Note: Dial *#06# to get the IMEI for your device
       </div>

      </Row>
     </div>
     {showSkuScreen &&
      <div style={{}}>
       <Row>
        <div className='dt-input-title'>Model</div>
        <Col xs={12} style={{ marginTop: '16px' }}>
         {
          <Dropdown
           id='dropdown'
           value={selectedModel && selectedModel.value}
           options={products}
           placeholder='Select from the list'
           showDownArrow={true}
           handleOnChange={(v) => {
            setSelectedModel(v);
            localStorage.setItem("ampleModelName", v.value)
            onProductSelection(v);
           }}
           filterBy='value'
           searchText='Select Device Model'
          />

         }
        </Col>
       </Row>
       <div style={{ marginTop: '20px' }} className='dt-input-title'>Variant</div>
       <Row>
        <Col xs={12} style={{ marginTop: '16px' }}>
         {

          <Dropdown
           id='variant dropdown'
           value={selectedVariant}
           options={skuDetails}
           placeholder='Select from the list'
           showDownArrow={true}
           handleOnChange={(v) => {
            setSelectedVariant(v.value);
            if (selectedModel && v.value) {
             const buttons = document.querySelectorAll(".imei_btn_disable");
             buttons.forEach((button) => {
              if (!button.classList.contains("imei_btn_rod")) {
               button.classList.remove("imei_btn_disable");
               button.classList.add('imei_btn_rod');
              }
             });
             setEnableShowConfirmBtn(true)
            } else {
             setEnableShowConfirmBtn(false)
            }
            localStorage.setItem('ampleVariant', v.value);
            localStorage.setItem("ampleVariantId", v.SkuModelID)
           }}
           filterBy='value'
           searchText='Select Variant'
          />

         }
        </Col>
       </Row>
      </div>}
    </div>
   </div>
   {apiError && <ErrorModal error={apiError} showModal={showModal} closeModal={closeModal} onClick={closeModal} /> || ""}


   {showSkuScreen && <div style={{ paddingBottom: '10px' }}><ButtonContainer
    isDisabled={!enableShowConfirmBtn}
    BtnOneText={'Confirm'}
    BtnTwoText={'Back'}
    onBtnOneClick={on_tradein_sku_continue_btn_click}
    onBtnTwoClick={on_back_btn_click}
    BtnOneClass={'pwa-continue-btn'}
    BtnTwoClass={'pwa-secondary-continue-btn'} /></div> || ""}

  </Container>
 );
}
export default DeviceDetails;